import { getStaffListToDisplay, } from './staff-list.mappers';
import { StaffWidgetSettingsKeys } from '@wix/bookings-app-builder-settings-const/dist/src/StaffWidget/Settings.const';
import { navigateToServiceListWithQuery } from '@wix/bookings-catalog-calendar-viewer-navigation';
import { sdk as imageClientSDK } from '@wix/image-kit';
var StaffListViewModel = /** @class */ (function () {
    function StaffListViewModel(_a) {
        var $widget = _a.$widget, $w = _a.$w, biLogger = _a.biLogger, wixCodeApi = _a.wixCodeApi;
        var _this = this;
        this.setStaffImage = function (image, $image) {
            if (image && _this.isElementVisible($image)) {
                $image.src = imageClientSDK.getScaleToFillImageURL(image.id || image.url, image.width, image.height, 228, 228);
                $image.tooltip = null;
            }
        };
        this.getStaffDetails = function (itemData) {
            return itemData.email && itemData.phone
                ? "".concat(itemData.email, "\n").concat(itemData.phone)
                : itemData.email
                    ? "".concat(itemData.email)
                    : itemData.phone
                        ? "".concat(itemData.phone)
                        : '';
        };
        this.wixCodeApi = wixCodeApi;
        this.$w = $w;
        this.$widget = $widget;
        this.biLogger = biLogger;
    }
    StaffListViewModel.prototype.setStaffList = function (staffDtoList, staffListWidgetSettings, translations) {
        if (staffListWidgetSettings === void 0) { staffListWidgetSettings = {}; }
        if (translations === void 0) { translations = {}; }
        this.setupReadyListeners(staffListWidgetSettings, translations);
        this.staffRepeater.data = getStaffListToDisplay(staffDtoList, staffListWidgetSettings);
    };
    StaffListViewModel.prototype.setupReadyListeners = function (staffListWidgetSettings, translations) {
        var _this = this;
        this.staffRepeater.onItemReady(function ($item, itemData) {
            _this.setStaffImage(itemData.image, $item('#staffImage'));
            var staffDetails = _this.getStaffDetails(itemData);
            var staffDescription = itemData.description;
            var buttonTextFromSettings = staffListWidgetSettings[StaffWidgetSettingsKeys.BOOK_BUTTON_TEXT];
            $item('#staffName').text = itemData.name;
            if (_this.isElementVisible($item('#staffImage'))) {
                if (!$item('#staffImage').alt) {
                    $item('#staffImage').alt = itemData.name;
                }
            }
            if (_this.isElementVisible($item('#staffDetails'))) {
                staffDetails
                    ? ($item('#staffDetails').text = staffDetails)
                    : _this.setDefaultAndCollapse($item('#staffDetails'), translations['bookings.staff-list.cta.book.details']);
            }
            if (_this.isElementVisible($item('#staffDescription'))) {
                staffDescription
                    ? ($item('#staffDescription').text = staffDescription)
                    : _this.setDefaultAndCollapse($item('#staffDescription'), translations['bookings.staff-list.cta.book.description']);
            }
            if (_this.isElementVisible($item('#staffButton'))) {
                $item('#staffButton').label = buttonTextFromSettings
                    ? buttonTextFromSettings
                    : translations['bookings.staff-list.cta.book.button'];
                $item('#staffButton').onClick(function () { return _this.staffClickHandler(itemData); });
            }
        });
    };
    StaffListViewModel.prototype.isElementVisible = function ($element) {
        return !$element.hasOwnProperty('length');
    };
    StaffListViewModel.prototype.setDefaultAndCollapse = function ($element, text) {
        $element.collapse();
        $element.text = text;
    };
    StaffListViewModel.prototype.staffClickHandler = function (itemData) {
        var shouldNavigateToSpecificSitePage = !!itemData.overridePageId;
        this.biLogger.sendStaffClicked(shouldNavigateToSpecificSitePage);
        var queryParamName = 'resource';
        var queryParamValue = itemData._id;
        shouldNavigateToSpecificSitePage
            ? this.wixCodeApi.location.navigateTo({
                type: 'PageLink',
                pageId: itemData.overridePageId,
            })
            : navigateToServiceListWithQuery({
                wixCodeApi: this.wixCodeApi,
                queryName: queryParamName,
                queryValue: queryParamValue,
            });
    };
    Object.defineProperty(StaffListViewModel.prototype, "staffRepeater", {
        get: function () {
            return this.$w('#staffRepeater');
        },
        enumerable: false,
        configurable: true
    });
    return StaffListViewModel;
}());
export { StaffListViewModel };
//# sourceMappingURL=staff-list.view-model.js.map